import { get, post } from '@/api/request';

const URI = "/warn"

// 用户管理-用户列表
export const listWarn = (page, size, params) => post(`${URI}/?page=${page}&size=${size}`, params);

export const deleteWarn = id => get(`${URI}/delete/${id}`);




// WEBPACK FOOTER //
// ./src/api/system/warn.js